import { AlertCircle, LogOut, RotateCw } from 'lucide-react'
import { Button } from '../../components/ui/Button'

export function WorkspaceBootstrapErrorView({ loading = false, onRetry, onLogout }) {
  return (
    <div className="text-center">
      <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
        <AlertCircle className="w-8 h-8 text-red-600" />
      </div>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Workspace setup needs another try</h1>
      <p className="text-gray-500 mb-6">
        We could not finish preparing your workspace. Your account is signed in, and you can retry setup now.
      </p>
      <div className="space-y-3">
        <Button
          variant="primary"
          fullWidth
          loading={loading}
          onClick={onRetry}
          icon={<RotateCw className="w-4 h-4" />}
        >
          Retry setup
        </Button>
        <Button
          variant="secondary"
          fullWidth
          onClick={onLogout}
          icon={<LogOut className="w-4 h-4" />}
        >
          Logout
        </Button>
      </div>
    </div>
  )
}
